/**
 * @param {string} term
 * @param {Map<string, string> | Record<string, string> | null | undefined} nameById
 * @returns {string}
 */
export const resolveTermDisplayName = (term, nameById) => {
  if (!term) return term;
  const id = term.toLowerCase();
  if (nameById instanceof Map) {
    return nameById.get(id) ?? term;
  }
  if (nameById && typeof nameById === 'object') {
    return nameById[id] ?? term;
  }
  return term;
};

/**
 * @param {string[] | null | undefined} terms
 * @param {Record<string, string> | null | undefined} explicitNames
 * @returns {Map<string, string>}
 */
export const buildNameMapForTerms = (terms, explicitNames) => {
  const map = new Map();
  for (const term of terms || []) {
    if (!term) continue;
    const id = term.toLowerCase();
    if (map.has(id)) continue;
    map.set(id, resolveTermDisplayName(term, explicitNames));
  }
  return map;
};
